// LIBRARIES
import styled from "styled-components";

// MISC
import { COLORS, SIZE, DEVICE_TYPE, MARGIN } from "constants/variables";

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  min-height: 100vh;
  padding-bottom: 70px;
  @media (max-width: ${DEVICE_TYPE.mobile}) {
    padding-bottom: 90px;
  }
  background-color: ${COLORS.Background};
`;

export const ContentContainer = styled.div<{ $hasSectionNavigation?: boolean }>`
  height: 100%;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-width: 300px;
  margin-top: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? "0" : "-75px"};
  @media (max-width: ${DEVICE_TYPE.tablet}) {
    /* margin-top: -94px; */
    margin-top: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? "0" : "-80px"};
  }
`;

export const HeaderWrapper = styled.div<{ $hasSectionNavigation?: boolean }>`
  z-index: 200;
  position: sticky;
  top: 0;
  width: 100%;
  border-radius: 0 0 24px 24px;
  box-shadow: ${({ $hasSectionNavigation }) => $hasSectionNavigation ? `0 4px 10px ${COLORS.boxShadow}` : "none"};
`;
export const FooterWrapper = styled.div`
  padding: ${SIZE.max84};

  @media (max-width: ${DEVICE_TYPE.mobileHeader}) {
    margin-top: 30px;
    padding: ${MARGIN.fix24};
  }
`;
export const GirdleWrapper = styled.div`
  z-index: 200;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
`;
